import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import Spinner from "./Spinner";

const GEO_URL = "/france-departements.geojson";
const MAX_BUBBLE_R = 26;
const MIN_BUBBLE_R = 5;

const FranceMap = ({ postalDistribution, loading }) => {
  const mapData = postalDistribution || {};

  const maxMapCount = Math.max(...Object.values(mapData), 1);

  return (
    <div className="bg-white rounded-2xl border border-slate-200/60 shadow-sm p-6">
      <div className="flex items-center justify-between mb-1">
        <div>
          <h3 className="font-medium text-slate-800 text-sm">Répartition géographique</h3>
          <p className="text-xs text-slate-400 mt-0.5">Par département · taille ∝ nombre de membres</p>
        </div>
        <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "#F0FDF4", color: "#059669" }}>
          {Object.values(mapData).reduce((a, b) => a + b, 0)} localisés
        </span>
      </div>
      {loading ? (
        <div className="flex items-center justify-center h-64 mt-4">
          <Spinner />
        </div>
      ) : (
        <>
          <ComposableMap
            projection="geoMercator"
            projectionConfig={{ center: [2.5, 46.5], scale: 2600 }}
            style={{ width: "100%", height: 290 }}
          >
            <ZoomableGroup>
              <Geographies geography={GEO_URL}>
                {({ geographies }) => (
                  <>
                    {geographies.map((geo) => (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill="#E8EDE8"
                        stroke="#fff"
                        strokeWidth={0.6}
                        style={{ default: { outline: "none" }, hover: { outline: "none" }, pressed: { outline: "none" } }}
                      />
                    ))}
                    {geographies.map((geo) => {
                      const code = geo.properties.code;
                      const count = mapData[code] || 0;
                      if (!count) return null;
                      const centroid = geoCentroid(geo);
                      const r = MIN_BUBBLE_R + Math.sqrt(count / maxMapCount) * (MAX_BUBBLE_R - MIN_BUBBLE_R);
                      return (
                        <Marker key={`b-${code}`} coordinates={centroid}>
                          <circle r={r} fill="#059669" fillOpacity={0.7} stroke="#fff" strokeWidth={1} />
                          {count >= 3 && (
                            <text textAnchor="middle" dy=".35em" fontSize={r > 12 ? 9 : 7} fill="#fff" fontWeight="700" style={{ pointerEvents: "none" }}>
                              {count}
                            </text>
                          )}
                        </Marker>
                      );
                    })}
                  </>
                )}
              </Geographies>
            </ZoomableGroup>
          </ComposableMap>
          <div className="flex items-center justify-end gap-5 mt-1">
            {[1, Math.max(Math.round(maxMapCount / 2), 2), maxMapCount]
              .filter((v, i, a) => a.indexOf(v) === i && v > 0)
              .map((v) => {
                const size = 2 * (MIN_BUBBLE_R + Math.sqrt(v / maxMapCount) * (MAX_BUBBLE_R - MIN_BUBBLE_R));
                return (
                  <div key={v} className="flex items-center gap-1.5">
                    <div className="rounded-full flex-shrink-0" style={{ width: size, height: size, backgroundColor: "#059669", opacity: 0.65 }} />
                    <span className="text-xs text-slate-400">{v}</span>
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
};

export default FranceMap;
